export const isWeixinBrowser = () => {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  }
  
  export const isAndroid = () => {
    return navigator.userAgent.indexOf('Android') > -1
  }
  
  export const isIOS = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent)
  }